import { render, staticRenderFns } from "./hpEvent.vue?vue&type=template&id=85a8a4aa&scoped=true&"
import script from "./hpEvent.vue?vue&type=script&lang=js&"
export * from "./hpEvent.vue?vue&type=script&lang=js&"
import style0 from "./hpEvent.vue?vue&type=style&index=0&id=85a8a4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a8a4aa",
  null
  
)

export default component.exports